import { useContext, useEffect, useRef } from "react";

import { CurrentOrganizationContext } from "./CurrentOrganizationContext";

export const useCurrentOrganizationContext = () => {
  return useContext(CurrentOrganizationContext);
};

export const useSwitchOrganization = () => {
  const { switchOrganization } = useCurrentOrganizationContext();
  return switchOrganization;
};

export const useAccessibleFederationsCount = () => {
  const { accessibleFederationsCount } = useCurrentOrganizationContext();
  return accessibleFederationsCount;
};

export const useAvailableFederationsCount = () => {
  const { availableFederationsCount } = useCurrentOrganizationContext();
  return availableFederationsCount;
};

export const useCurrentOrganization = () => {
  const { organization } = useCurrentOrganizationContext();
  return organization;
};

export const useOnCurrentOrganizationChange = (callback: () => void) => {
  const organization = useCurrentOrganization();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const isFirstRunRef = useRef(true);

  useEffect(() => {
    if (isFirstRunRef.current) {
      isFirstRunRef.current = false;
      return;
    }
    callbackRef.current();
  }, [organization?.id]);
};
